import { Injectable } from '@angular/core';
import { Address, AddressAPIResponse } from '../interfaces/adress';
import { Qualification, QualificationAPIResponse } from '../interfaces/qualification';


@Injectable({
  providedIn: 'root'
})

export class QualificationAdapter {

    public adapterToModel(qualificationFHIR: QualificationAPIResponse[]) : { qualifications: Qualification[], certifications: Qualification[] } {

        const qualifications: Qualification[] = [];
        const certifications: Qualification[] = [];
      
        qualificationFHIR.forEach((qualification: any) => {
      
          const type = qualification.code.type

          const dadosTransformados = {
            name: qualification.identifier[0].value,
            instituition: qualification.issuer.display,
            dateConclusion: qualification.period.end,
            type: type,
            level: qualification.code.text,
          };
      
          if (type === 'QUALIFICATION') {
            qualifications.push(dadosTransformados);
          } else if (type === 'COURSE') {
            certifications.push(dadosTransformados);
          }
        });
      
        return {qualifications, certifications};
    }


    public adaptToAPIFormat(qualifications: Qualification[], certificates: Qualification[] ): QualificationAPIResponse[]{

        let qualification : Qualification[] = [...qualifications, ...certificates ]
        let qualificationFHIR : QualificationAPIResponse[]

        qualificationFHIR = qualification?.map( qualification => {
        
              return {
                "identifier": [
                  {
                    "system": "http://example.org/UniversityIdentifier",
                    "value": qualification.name
                  }
                ],
                "code" : {
                  "text" : qualification.level,
                  "type": qualification.type,
                }, 
                "period" : {
                  "end" : qualification.dateConclusion
                },
                "issuer": {
                  "display" : qualification.instituition
                }
              }
            })
        
        return qualificationFHIR   
    }


}